export default "__VITE_ASSET__BIS5BzLc__"